export function isOfflineId(id) {
  return id?.length === 36
}
